export const transbankAppis = `${process.env.VUE_APP_API || 'http://localhost:3000'}/api`
